export default "__VITE_ASSET__D1YQVRPW__"